module.exports = __webpack_public_path__ + "static/img/success.75a96c9f.png";